<template>
  <div id="pageRoot">
    <h2 id="text01" class="pageElement">
      ¿Vive acaso en la azotea?<br />
      ¿Se ha metido en un rincon?<br />
      ¿Esta abajo de la cama?<br />
      ¿Vive oculto en una flor?<br />
      <br />
      Nadie sabe donde vive.<br />
      Nadie en la casa lo vio.<br />
      Pero todos lo escuchamos.<br />
      Cuando llueve: Glo Glo Glo
    </h2>
    <p id="foot" class="textBase">
      José Sebastián Tallon (Argentina), Colihue.
    </p>

    <!-- SVG BACKGROUND-------------------------------------------------------->

    <img
      id="clouds"
      src="/pages/img/sordoglo/svgGlo4Clouds.svg"
      class="pageElement"
    />
    <img
      id="tree"
      src="/pages/img/sordoglo/svgGlo4Tree.svg"
      class="pageElement"
    />
    <img
      id="street"
      src="/pages/img/sordoglo/svgGlo3Street.svg"
      class="pageElement"
    />
    <img
      id="houses"
      src="/pages/img/sordoglo/svgGlo4Houses.svg"
      class="pageElement"
    />
    <img
      id="students"
      src="/pages/img/sordoglo/svgGlo4Students.svg"
      class="pageElement"
    />
    <img
      id="woman"
      src="/pages/img/sordoglo/svgGlo4Woman.svg"
      class="pageElement"
    />
    <img
      id="moustache"
      src="/pages/img/sordoglo/svgGlo4Moustache.svg"
      class="pageElement"
    />
    <img
      id="rain01"
      src="/pages/img/sordoglo/svgGlo3Rain02.svg"
      class="pageElement"
    />
    <img
      id="rain02"
      src="/pages/img/sordoglo/svgGlo1Rain.svg"
      class="pageElement"
    />
    <img
      id="gloGlobe"
      src="/pages/img/sordoglo/svgGlo4GloGlobe.svg"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#text01 {
  position: absolute;
  left: 23px;
  top: 49px;
  z-index: 10;
}
#foot {
  position: absolute;
  left: 490px;
  top: 707px;
}
#clouds {
  position: absolute;
  left: 356px;
  top: 33px;
}
#tree {
  position: absolute;
  left: 814px;
  top: 35px;
}
#street {
  position: absolute;
  left: 5px;
  top: 585px;
}
#houses {
  position: absolute;
  left: 235px;
  top: 324px;
}
#students {
  position: absolute;
  left: 164px;
  top: 453px;
}
#woman {
  position: absolute;
  left: 521px;
  top: 440px;
}
#moustache {
  position: absolute;
  left: 855px;
  top: 485px;
}
#rain01 {
  position: absolute;
  width: 505.06px;
  height: 233.92px;
  left: -35px;
  top: 339px;
}
#rain02 {
  position: absolute;
  width: 790px;
  height: 690.21px;
  left: 317px;
  top: -131px;
}
#gloGlobe {
  position: absolute;
  left: 400px;
  top: 161px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 4.mp4"]
    }
  }
}
</script>